/**
 * @returns {Object} - Object containing debounce function
 */
export function useDebounce() {
    /**
     * Creates a debounced version of a function
     * @param {Function} func - The function to debounce
     * @param {Number} wait - The number of milliseconds to delay
     * @returns {Function} - The debounced function
     */
    function debounce(func, wait = 300) {
        let timeout;
        return function(...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    return {
        debounce
    };
}
